import { useCallback } from 'react';
import { useI18n } from '@/hooks/useI18n';
import { codigoDe } from './errores';

/**
 * Convierte lo que lanzó el puerto en algo que se le pueda enseñar a una
 * persona, en el idioma que eligió.
 *
 * Sustituye a `useMensajeDeError`, que se fue con el retiro del backend el
 * 2026-09-18 y que traducía **cinco** familias de error de cinco servicios
 * distintos. Aquí hay una sola, así que el hook cabe en diez líneas.
 *
 * Y una diferencia deliberada con el viejo: aquél caía al `error.message`
 * original cuando no reconocía el código, razonando que un mensaje real dice
 * más que uno genérico. **Aquí no.** Los `message` de este puerto son códigos,
 * no frases, así que enseñarlos colaría `credenciales` a la pantalla. Lo que no
 * se reconoce se dice como `generico`.
 */
export function useMensajeDeAcceso() {
  const { t } = useI18n();

  return useCallback((error: unknown): string => t.area.errores[codigoDe(error)], [t]);
}
